import { styled } from "@linaria/react";

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  &[data-justify="between"] {
    justify-content: space-between;
  }

  &[data-justify="center"] {
    justify-content: center;
  }

  &[data-justify="end"] {
    justify-content: flex-end;
  }

  &[data-align="start"] {
    align-items: flex-start;
  }

  &[data-align="end"] {
    align-items: flex-end;
  }

  &[data-width="stretch"] {
    width: stretch;
  }

  &[data-width="full"] {
    width: 100%;
  }

  &[data-width="min"] {
    width: min-content;
  }

  &[data-height="full"] {
    height: 100%;
  }

  &[data-gap="none"] {
    gap: 0;
  }
`;
